import React from 'react';
import type { Tag as TagType } from '@whizz/api-model/dist/@types/endpoints/Tags';
import { Tag } from '.';
import { useI18n } from '@whizz/react-i18n';
import { Loader } from '../../../../../components';

const TagsBlock = ({ tags, handleEdit, handleDelete, isLoading }: Props): JSX.Element => {
  const { translate } = useI18n();

  const schoolTags = tags.filter((tag: TagType) => !tag.isDefault);
  const schoolDefaultTags = tags.filter((tag: TagType) => tag.isDefault);

  if (isLoading) {
    return (
      <Loader />
    );
  }

  return (
    <>
      <div className={'space-y-3'} data-cy={'rm-tags-default'}>
        <h2 className={'font-bold'}>{translate('pages.ROSTER_MANAGEMENT.TAGS.DEFAULT_TAGS')}</h2>
        {schoolDefaultTags.map((tag) => {
          const translatedTag: TagType = {
            ...tag,
            abbreviation: translate(`pages.ROSTER_MANAGEMENT.TAGS.DEFAULT_TAGS_ABBREVIATIONS.${tag.abbreviation}`, { 'defaultValue': tag.abbreviation }),
            description: translate(`pages.ROSTER_MANAGEMENT.TAGS.DEFAULT_TAGS_DESCRIPTIONS.${tag.abbreviation}`, { 'defaultValue': tag.description }),
          };
          return (
            <Tag
              key={translatedTag.abbreviation}
              abbreviation={translatedTag.abbreviation}
              color={translatedTag.color}
              handleEdit={() => handleEdit(translatedTag, true)}
            >
              {translatedTag.description}
            </Tag>
          );})}
      </div>
      {schoolTags.length ? (
        <div className={'space-y-3'}>
          <h2 className={'font-bold'}>{translate('pages.ROSTER_MANAGEMENT.TAGS.CUSTOM_TAGS')}</h2>
          {schoolTags.map((tag) => (
            <Tag
              key={tag.abbreviation}
              abbreviation={tag.abbreviation}
              color={tag.color}
              handleEdit={() => handleEdit(tag)}
              handleDelete={() => handleDelete(tag)}
            >
              {tag.description}
            </Tag>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default TagsBlock;


interface Props {
  tags: TagType[];
  handleEdit: (tag: TagType, isDefault?: boolean) => void;
  handleDelete: (tag: TagType) => void;
  isLoading: boolean;
}
